module.exports = __webpack_public_path__ + "static/media/f.1bb9a56a.jpg";